// C:\VUE3\platform\src\utils\wait.js
export const wait = (ms) => new Promise((res) => setTimeout(res, ms));
